// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WnCB","location":"Header_location__PYR3o"};